module.exports = __webpack_public_path__ + "static/media/s1.1937d891.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/s1.png
// module id = 11
// module chunks = 0